import { useState, useEffect } from "react";
import {
  Button,
  CardHeader,
  Dialog,
  DialogContent,
  Grid,
  TextField,
  Box,
  DataGrid,
  IconButton,
  Tooltip,
} from "../../../../components";
import { notification, ProdutosService } from "../../../../services";

function ProdutoAplicacaoDialog({
  open,
  setOpen,
  produtoId,
  produto,
  setProduto,
  produtoEntity,
}) {
  const produtoService = new ProdutosService();
  const [aplicacoesProduto, setAplicacoesProduto] = useState([]);

  const [formAplicacao, setFormAplicacao] = useState({
    id: null,
    nome: "",
    descricao: "",
  });

  useEffect(() => {
    if (!open) {
      setFormAplicacao({ id: null, nome: "", descricao: "" });
    }
    if (open && produto?.aplicacoes?.length) {
      setAplicacoesProduto(produto.aplicacoes);
    }
  }, [open, produto]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormAplicacao((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddUpdateAplicacao = () => {
    if (!formAplicacao.nome.trim() || !formAplicacao.descricao.trim()) {
      return notification.alertaGenericos(
        "Por favor, preencha o nome da aplicação e a descrição."
      );
    }

    if (formAplicacao.id) {
      setAplicacoesProduto((prevState) =>
        prevState.map((app) =>
          app.id === formAplicacao.id ? { ...formAplicacao } : app
        )
      );
    } else {
      const newId =
        aplicacoesProduto.length > 0
          ? Math.max(...aplicacoesProduto.map((app) => app.id)) + 1
          : 1;
      setAplicacoesProduto((prevState) => [
        ...prevState,
        { ...formAplicacao, id: newId },
      ]);
    }
    setFormAplicacao({ id: null, nome: "", descricao: "" });
  };

  const handleEditAplicacao = (id) => {
    const aplicacaoToEdit = aplicacoesProduto.find((app) => app.id === id);
    if (aplicacaoToEdit) {
      setFormAplicacao(aplicacaoToEdit);
    }
  };

  const handleDeleteAplicacao = (id) => {
    setAplicacoesProduto((prevState) =>
      prevState.filter((app) => app.id !== id)
    );

    if (formAplicacao.id === id) {
      setFormAplicacao({ id: null, nome: "", descricao: "" });
    }
  };

  const handleSave = async () => {
    const aplicacoes = aplicacoesProduto.map((app) => ({
      nome: app.nome,
      descricao: app.descricao,
    }));
    if (produtoId) {
      const response = await produtoService.atualizarAplicacoes(
        produtoId,
        aplicacoes
      );
      if (!response.isAxiosError) {
        notification.alteracaoSucesso();
      }
    } else {
      produtoEntity.setHandleChangeInput("aplicacoes", aplicacoes);
      setProduto((prevState) => ({ ...prevState, ...produtoEntity }));
    }
    handleClose();
  };

  const colunas = [
    {
      field: "nome",
      headerName: "Aplicação",
      flex: 1,
      minWidth: 150,
      valueGetter: (params) => params.value.toUpperCase(),
    },
    {
      field: "descricao",
      headerName: "Descrição",
      sortable: false,
      flex: 1.5,
      minWidth: 250,
    },
    {
      field: "actions",
      headerName: "Ações",
      sortable: false,
      filterable: false,
      width: 120,
      renderCell: (params) => (
        <Box sx={{ display: "flex", gap: 0.5 }}>
          <IconButton
            color="info"
            size="small"
            onClick={() => handleEditAplicacao(params.row.id)}
          >
            <Tooltip title="Editar" arrow>
              <i className="ph-fill ph-pencil" style={{ fontSize: 20 }}></i>
            </Tooltip>
          </IconButton>
          <IconButton
            color="error"
            size="small"
            onClick={() => handleDeleteAplicacao(params.row.id)}
          >
            <Tooltip title="Excluir" arrow>
              <i className="ph-fill ph-trash" style={{ fontSize: 20 }}></i>
            </Tooltip>
          </IconButton>
        </Box>
      ),
    },
  ];

  return (
    <Dialog maxWidth={"lg"} fullWidth open={open} onClose={handleClose}>
      <DialogContent>
        <CardHeader
          title="Aplicações do Produto"
          action={
            <Button onClick={handleClose} variant="contained" color="padrao">
              Fechar
            </Button>
          }
        />
        <Grid container spacing={3} sx={{ mt: 2 }}>
          <Grid item xs={12} md={5}>
            <TextField
              label="Nome da Aplicação"
              variant="outlined"
              fullWidth
              name="nome"
              value={formAplicacao.nome}
              onChange={handleFormChange}
              margin="normal"
              size="small"
            />
            <TextField
              id="descricao"
              name="descricao"
              label="Descrição"
              margin="normal"
              fullWidth
              multiline
              rows={6}
              value={formAplicacao.descricao}
              onChange={handleFormChange}
              variant="outlined"
              size="small"
            />
            <Button
              variant="contained"
              color="success"
              fullWidth
              sx={{ mt: 2 }}
              onClick={handleAddUpdateAplicacao}
            >
              {formAplicacao.id ? "Atualizar Aplicação" : "Adicionar Aplicação"}
            </Button>
            {formAplicacao.id && (
              <Button
                variant="outlined"
                color="secondary"
                fullWidth
                sx={{ mt: 1 }}
                onClick={() =>
                  setFormAplicacao({ id: null, nome: "", descricao: "" })
                }
              >
                Limpar Formulário
              </Button>
            )}
          </Grid>

          <Grid container xs={1} className="d-flex justify-content-center">
            <hr className="vr" />
          </Grid>

          <Grid item xs={12} md={6} sx={{ mt: 1 }}>
            <DataGrid
              rows={aplicacoesProduto}
              columns={colunas}
              disableAcoes
              disableRowSelectionOnClick
              hideFooterPagination
            />
          </Grid>
        </Grid>

        <Box sx={{ display: "flex", justifyContent: "flex-end", m: 2, gap: 1 }}>
          <Tooltip title="Salvar todos os registros" placement="left">
            <Button onClick={handleSave} variant="contained" color="primary">
              Salvar
            </Button>
          </Tooltip>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default ProdutoAplicacaoDialog;
